import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Header from 'components/Modal/Header';
import Modal from 'components/Modal';

const ClearConfirmationModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Header title={t('clear_confirmation')} subtitle={t('are_you_shure_to_clear') + '?'} />
      <Modal.Footer
        confirmAction={() => modalProps.func()}
        confirmText={t('continua')}
        closeButtonText={t('annulla')}
      />
    </>
  );
};

export default ClearConfirmationModal;
